<template>
  <div class="personal">
    <el-form :model="form" ref="myForm" :rules="rules" hide-required-asterisk>
      <!-- 驗證類型 -->
      <el-form-item :label="$t('hzmbG.label.validType')" prop="type">
        <el-select v-model="form.type" filterable @change="changeType">
          <el-option
            v-for="item in [
              { code: 'approveNo', label: $t('hzmbG.label.approveNo') },
              {
                code: 'registrationNo',
                label: $t('hzmbG.label.registrationNo'),
              },
            ]"
            :key="item.code"
            :label="item.label"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- 澳門批准編號 -->
      <el-form-item
        v-if="form.type === 'approveNo'"
        :label="$t('hzmbG.label.approveNo')"
        prop="approveNo"
      >
        <el-input
          v-model="form.approveNo"
          maxlength="20"
          :placeholder="$t('hzmbG.message.approveNo')"
        ></el-input>
      </el-form-item>
      <!-- 香港車輛登記號碼 -->
      <el-form-item
        v-if="form.type === 'registrationNo'"
        :label="$t('hzmbG.label.registrationNo')"
        prop="registrationNo"
      >
        <el-input
          v-model="form.registrationNo"
          maxlength="8"
          :placeholder="$t('hzmbG.message.registrationNo')"
          @input="inputToUpperCase($event, 'registrationNo')"
        ></el-input>
      </el-form-item>
      <!-- 車身編號 -->
      <el-form-item
        v-if="form.type === 'registrationNo'"
        :label="$t('hzmbG.label.identificationNoLast4')"
        prop="identificationNo"
      >
        <el-input
          v-model="form.identificationNo"
          maxlength="4"
          :placeholder="$t('hzmbG.message.identificationNoLast4')"
          @input="inputToUpperCase($event, 'identificationNo')"
        ></el-input>
      </el-form-item>
      <el-form-item
        :label="$t('hzmbG.label.registerType')"
        prop="registerType"
        :rules="[
          {
            required: true,
            message: $t('message.formRuleMessage.notNull'),
          },
        ]"
      >
        <el-select
          v-model="form.registerType"
          :placeholder="$t('hzmbG.message.registerType')"
          @change="onRegisterTypeChange"
        >
          <el-option
            v-for="item in REGISTERTYPE"
            :key="item"
            :value="item"
            :label="item | registerType"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- 身份證明文件種類 -->
      <el-form-item
        v-if="form.registerType === 'PERSON'"
        :label="$t('hzmbG.label.identType')"
        prop="identType"
      >
        <el-select v-model="form.identType">
          <el-option
            v-for="(item, i) in identTypes"
            :key="i"
            :value="item.codeKey"
            :label="`${item.codeKey}-${item.codeCname}-${item.codePname}`"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- 身份證明文件號碼 -->
      <el-form-item
        v-if="form.registerType === 'PERSON'"
        :label="$t('hzmbG.label.identNo')"
        prop="identNo"
      >
        <el-input
          v-model="form.identNo"
          maxlength="50"
          :placeholder="$t('hzmbG.message.identNo')"
        ></el-input>
      </el-form-item>
      <el-form-item
        v-if="form.registerType === 'COMPANY'"
        :label="$t('hzmbG.label.companyRegistrationType')"
        prop="companyRegistrationType"
        :rules="[
          {
            required: true,
            message: $t('message.formRuleMessage.notNull'),
          },
        ]"
      >
        <el-select v-model="form.companyRegistrationType">
          <el-option
            v-for="(item, i) in companyRegistrationTypes"
            :key="i"
            :value="item.codeKey"
            :label="`${item.codeKey}-${item.codeCname}-${item.codePname}`"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="form.registerType === 'COMPANY'"
        :label="$t('hzmbG.label.companyRegistrationNo')"
        prop="companyRegistrationNo"
        :rules="[
          {
            required: true,
            message: $t('message.formRuleMessage.notNull'),
          },
        ]"
      >
        <el-input
          v-model="form.companyRegistrationNo"
          maxlength="50"
          :placeholder="$t('hzmbG.message.companyRegistrationNo')"
        >
        </el-input>
      </el-form-item>
      <!-- 澳門流動電話 -->
      <el-form-item
        :label="$t('message.Verification.mobile')"
        prop="mobile"
        :rules="[
          {
            required: true,
            message: $t('message.formRuleMessage.notNull'),
          },
          {
            pattern:
              form.mobileAreaCode === '853' ? /[6]{1}[0-9]{7}/ : /[0-9]{8}/,
            message: $t('message.formRuleMessage.macauMobile'),
            trigger: 'blur',
          },
        ]"
      >
        <div class="m-mobile_row">
          <el-select
            v-model="form.mobileAreaCode"
            :placeholder="$t('hzmbG.label.mobileAreaCode')"
          >
            <el-option
              v-for="item in areas"
              :key="item.value"
              :value="item.value"
              :label="item.text"
            ></el-option>
          </el-select>
          <el-input
            v-model.number="form.mobile"
            :placeholder="$t('message.Verification.mobile_placeholder')"
            maxlength="8"
          ></el-input>
        </div>
      </el-form-item>
      <!-- 手機驗證碼 -->
      <el-form-item
        :label="$t('message.Verification.phone_code')"
        prop="captcha"
      >
        <div class="captcha_row" style="width: 100%">
          <el-input
            v-model="form.captcha"
            :placeholder="$t('message.Verification.phone_code_placeholder')"
            @keyup.enter.native="submit"
          ></el-input>
          <el-button
            v-show="show"
            type="primary"
            class="getVerify_btn"
            @click="getCode"
            :disabled="!this.form.mobile"
            :loading="getCodeLoading"
            >{{ $t("message.get_phone_code") }}</el-button
          >
          <el-button
            v-show="!show"
            type="primary"
            class="getVerify_btn"
            disabled
            >{{ count }}{{ $t("message.second") }}</el-button
          >
        </div>
      </el-form-item>
      <el-form-item class="submit_btn">
        <GradientBtn @click="submit" :loading="loading">{{
          $t("message.verify_submit")
        }}</GradientBtn>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import i18n from "../../../../public/lang/index";
import LoginAPI from "@/api/hzmb-gh/LoginAPI";
import HzmbGCancelApplicationAPI from "@/api/hzmb-gh/HzmbGCancelApplicationAPI";
import GradientBtn from "../../../components/GradientBtn";
import VssViewAPI from "@/api/hzmb-gh/VssViewAPI";
import { REGISTERTYPE } from "@/enums";
import { registerType } from "@/filters";
import { checkServerStatus } from "@/util/util";
export default {
  components: { GradientBtn },
  data() {
    return {
      serviceType: "HZMB_G_CANCEL",
      form: {
        type: "registrationNo",
        mobileAreaCode: "852",
      },
      show: true,
      loading: false,
      getCodeLoading: false,
      timer: null,
      count: "",
      isGetCode: false,
      identTypes: [],
      companyRegistrationTypes: [],
      areas: [
        { value: "853", text: i18n.t("hzmbG.enum.areas.macau") },
        { value: "852", text: i18n.t("hzmbG.enum.areas.hongkong") },
      ],
      REGISTERTYPE,
      rules: {
        approveNo: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
          },
        ],
        registrationNo: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
          },
        ],
        identificationNo: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
          },
        ],
        identType: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
          },
        ],
        identNo: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
          },
        ],
        captcha: [
          {
            max: 10,
            message: i18n.t("message.formRuleMessage.maxLength10"),
            trigger: "blur",
          },
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  filters: { registerType },
  computed: {
    idTypeLocalce() {
      return (
        ["codeCname", "codePname"][
          ["ZH_TW", "PT"].indexOf(this.$i18n.locale)
        ] || "codeMasterCname"
      );
    },
  },
  methods: {
    // 輸入字母轉大寫
    inputToUpperCase(val, name) {
      this.form[name] = val.toUpperCase();
    },
    getCode() {
      this.rules.captcha.splice(1, 1);
      this.$refs.myForm.validate((valid) => {
        if (valid) {
          const TIME_COUNT = 60;
          if (!this.timer) {
            this.count = TIME_COUNT;
            const { registrationNo, identificationNo, mobile, mobileAreaCode, approveNo } =
              this.form;
            const serviceType = this.serviceType;
            if (mobile) {
              this.getCodeLoading = true;
              LoginAPI.captcha(
                `${mobileAreaCode}${mobile}`,
                serviceType,
                null,
                registrationNo,
                identificationNo,
                null,
                null,
                approveNo,
              )
                .then(() => {
                  this.getCodeLoading = false;
                  this.show = false;
                  this.isGetCode = true;
                  this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                      this.count--;
                    } else {
                      this.show = true;
                      clearInterval(this.timer);
                      this.timer = null;
                    }
                  }, 1000);
                })
                .catch((err) => {
                  this.getCodeLoading = false;
                  this.$error(err);
                });
            } else {
              this.$refs.myForm.validateField("taxiCertNo");
            }
          }
          this.rules.captcha.push({
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
            trigger: "blur",
          });
        } else {
          this.rules.captcha.push({
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
            trigger: "blur",
          });
        }
      });
    },
    submit() {
      if (!this.isGetCode) {
        this.$message({
          type: "warning",
          message: this.$t("message.getCode_first"),
        });
        return false;
      }
      this.$refs.myForm.validate((valid) => {
        if (valid) {
          this.check();
        }
      });
    },
    // 修改驗證類型
    changeType() {
      this.$delete(this.form, "approveNo");
      this.$delete(this.form, "registrationNo");
      this.$delete(this.form, "identificationNo");
    },
    // 准入
    async check() {
      try {
        this.loading = true;
        const serviceType = this.serviceType;
        await checkServerStatus(serviceType);
        const {
          mobileAreaCode,
          mobile,
          captcha,
          approveNo,
          registrationNo,
          identificationNo,
          identType,
          identNo,
          companyRegistrationType,
          companyRegistrationNo,
        } = this.form;
        const check = await LoginAPI.mobileCheck(
          serviceType,
          `${mobileAreaCode}${mobile}`,
          captcha,
          registrationNo,
          identificationNo
        );
        localStorage.setItem("authentication", check.authentication);
        const application = await HzmbGCancelApplicationAPI.check(
          serviceType,
          approveNo,
          registrationNo,
          identificationNo,
          mobileAreaCode,
          mobile,
          identType,
          identNo,
          companyRegistrationType,
          companyRegistrationNo
        );
        localStorage.setItem("form", "");
        this.$store.commit("changeDocumentType", []);
        localStorage.setItem("verifyForm", JSON.stringify(this.form));
        this.$router.push(`/hzmb-g-cancel/application/${application.id}`);
      } catch (error) {
        if (error.code === "DUPLICATE_APPROVING_APPLICATION") {
          this.$alert(
            this.$t("message.ErrorMessage.DUPLICATE_APPROVING_APPLICATION")
          );
        } else {
          this.$error(error);
        }
      } finally {
        this.loading = false;
      }
    },
    onRegisterTypeChange(val) {
      if (val === "PERSON") {
        this.$delete(this.form, "companyRegistrationType");
        this.$delete(this.form, "companyRegistrationNo");
      }
      if (val === "COMPANY") {
        this.$delete(this.form, "identType");
        this.$delete(this.form, "identNo");
      }
    },
  },
  async created() {
    try {
      this.identTypes = await VssViewAPI.getHzmbGByTypePublic("PERSON");
      this.companyRegistrationTypes = await VssViewAPI.getHzmbGByTypePublic(
        "COMPANY"
      );
    } catch (error) {
      this.$error(error);
    }
  },
};
</script>

<style lang="scss" scoped>
.m-mobile_row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  .el-select {
    width: 200px;
    margin-right: 16px;
  }
}
.captcha_row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.getVerify_btn {
  margin-left: 16px;
  min-width: 150px;
}
.submit_btn {
  text-align: center;
  margin: 76px 0;
}
</style>
